import { render, staticRenderFns } from "./PermissionManager.vue?vue&type=template&id=fd4d103e&scoped=true&"
import script from "./PermissionManager.vue?vue&type=script&lang=js&"
export * from "./PermissionManager.vue?vue&type=script&lang=js&"
import style0 from "./PermissionManager.vue?vue&type=style&index=0&id=fd4d103e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4d103e",
  null
  
)

export default component.exports